import React, { useEffect, useState } from "react";
import { onUploadProgress } from "@/lib/api";
import { UploadCloud, CheckCircle2 } from "lucide-react";

export default function UploadProgress() {
  const [state, setState] = useState({ active: false, pct: 0, filename: "" });
  useEffect(() => onUploadProgress((s) => setState((prev) => ({ ...prev, ...s }))), []);
  if (!state.active) return null;
  const done = state.pct >= 100;
  return (
    <div data-testid="upload-progress" className="upl-prog" role="status" aria-live="polite">
      <div className="upl-prog-row">
        <span className="upl-prog-ic">{done ? <CheckCircle2 size={18} /> : <UploadCloud size={18} />}</span>
        <div className="upl-prog-body">
          <div className="upl-prog-top">
            <span className="upl-prog-name">{done ? "¡Subido!" : "Subiendo"} · {state.filename}</span>
            <span className="upl-prog-pct" data-testid="upload-progress-pct">{state.pct}%</span>
          </div>
          <div className="upl-prog-track"><div className="upl-prog-fill" style={{ width: `${state.pct}%` }} /></div>
        </div>
      </div>
    </div>
  );
}
